import React from "react"
import { Link } from "gatsby"
import { useStore } from "../../Context/StoreContext"

import Burger from "./Burger"
import Menu from "./Menu"
import { savorlyLogo } from "../../utils/imageUpload"
import OpenCart from "./OpenCart"
import {
  CartSection,
  BurgerWrapper,
  SubscribeMessage,
  LogoWrapper,
  NavLink,
  Nav,
} from "../../styles/NavbarStyles"

export const websiteMap = [
  {
    link: "/shop",
    where: "Shop",
  },
 /*  {
    link: "/discover",
    where: "Discover",
  }, */
  {
    link: "/about",
    where: "About",
  },
  {
    link: "/find-us",
    where: "Find Us",
  },
  {
    link: "/blog",
    where: "Blog",
  },
]

const Navbar = (props) => {
  const [open, setOpen] = React.useState(false)
  const { toggleCart } = useStore()

  const { state } = useStore()
  const { cart } = state
  const totalItems = cart.length

  return (
    <>
      <Nav>
        <div className="base">
          <NavLink length={websiteMap.length}>
            {websiteMap.map((el) => (
              <li key={el.link}>
                <Link activeClassName="activeNav" to={el.link}>
                  {el.where}
                </Link>
              </li>
            ))}
          </NavLink>
          <LogoWrapper>
            <Link to="/" className="Logo">
              <img src={savorlyLogo} alt="Savorly's Logo" />
            </Link>
          </LogoWrapper>
          <CartSection>
            <OpenCart totalItems={totalItems} onClick={toggleCart} />
          </CartSection>
          <BurgerWrapper>
            <Burger open={open} setOpen={setOpen} />
            <Menu open={open} setOpen={setOpen} />
          </BurgerWrapper>
        </div>
        {props.output && (
          <SubscribeMessage output={props.output}>
            {props.output}
          </SubscribeMessage>
        )}
      </Nav>
    </>
  )
}

export default Navbar
